import React from 'react'
import AuthenticationProvider from '../../providers/authentication'
import { QueryCache, ReactQueryCacheProvider} from 'react-query'
import ViewportPorvider from '../../providers/viewport'
import ConfirmationDialogProvider from '../../providers/confirmation-dialog'
import ConfigureDiscussionProvider from '../discussions/configuration-provider'

const queryCache = new QueryCache({
    defaultConfig: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
})

const Providers = ({ children }) => {
    return (
        <ReactQueryCacheProvider queryCache={queryCache}>
            <ViewportPorvider>
                <AuthenticationProvider>
                    <ConfirmationDialogProvider>
                        <ConfigureDiscussionProvider>
                            {children}
                        </ConfigureDiscussionProvider>
                    </ConfirmationDialogProvider>
                </AuthenticationProvider>
            </ViewportPorvider>
        </ReactQueryCacheProvider>
    )
}

export default Providers
